import { gql } from '@apollo/client'

import { DebitCardTransactionTypeV2 } from 'types/gql-global-types'
import { GetRecipientDetailsDebitCardTransactionV2Fragment } from 'types/gql-types/GetRecipientDetailsDebitCardTransactionV2Fragment'

export const cardTransactionTypes = [
  DebitCardTransactionTypeV2.ATM_IN,
  DebitCardTransactionTypeV2.ATM_OUT,
  DebitCardTransactionTypeV2.PURCHASE,
  DebitCardTransactionTypeV2.PURCHASE_CNP,
  DebitCardTransactionTypeV2.REFUND_CNP,
  DebitCardTransactionTypeV2.REFUND,
]

export const externalOutgoingTransactionTypes = [
  DebitCardTransactionTypeV2.DE_OUT,
  DebitCardTransactionTypeV2.NPP_OUT,
]

export const externalIncomingTransactionTypes = [
  DebitCardTransactionTypeV2.DE_IN,
  DebitCardTransactionTypeV2.NPP_IN,
]

export const internalTransferTransactionTypes = [
  DebitCardTransactionTypeV2.TRANSFER_IN,
  DebitCardTransactionTypeV2.TRANSFER_OUT,
]

export const adjustmentTransactionTypes = [
  DebitCardTransactionTypeV2.ADJUSTMENT_DEPOSIT,
  DebitCardTransactionTypeV2.ADJUSTMENT_WITHDRAWAL,
]

export const bpayTransactionTypes = [
  DebitCardTransactionTypeV2.BPAY_IN,
  DebitCardTransactionTypeV2.BPAY_OUT,
]

export const transferOutReversalTransactionTypes = [
  DebitCardTransactionTypeV2.DE_OUT_RETURN,
  DebitCardTransactionTypeV2.NPP_OUT_RETURN,
]

export const getRecipientDetails = (
  transaction: GetRecipientDetailsDebitCardTransactionV2Fragment
) => {
  switch (transaction.type) {
    case DebitCardTransactionTypeV2.DE_OUT:
    case DebitCardTransactionTypeV2.NPP_OUT:
      return {
        bsbNumber: transaction.payeeDetails?.accountDetails?.bsb,
        recipientAccountName: transaction.payeeDetails?.accountDetails?.name,
        recipientAccountNumber:
          transaction.payeeDetails?.accountDetails?.account,
        referencePayee: transaction.referencePayee,
      }
    case DebitCardTransactionTypeV2.DE_IN:
    case DebitCardTransactionTypeV2.NPP_IN:
      return {
        bsbNumber: transaction.payeeDetails?.accountDetails?.bsb,
        recipientAccountName: transaction.payeeDetails?.accountDetails?.name,
        recipientAccountNumber:
          transaction.payeeDetails?.accountDetails?.account,
        referencePayee: null,
      }
    default:
      return {
        bsbNumber: null,
        recipientAccountName: null,
        referencePayee: null,
      }
  }
}

getRecipientDetails.fragments = {
  DebitCardTransactionV2: gql`
    fragment GetRecipientDetailsDebitCardTransactionV2Fragment on DebitCardTransactionV2 {
      referencePayee
      type
      payeeDetails {
        accountDetails {
          account
          bsb
          name
        }
        bpayDetails {
          nickname
          billerName
          billerCode
          crn
        }
      }
    }
  `,
}
